<template>
    <div class="components-container">
        <!-- 操作框 -->
        <div class="filter-container" style="text-align: left;">
            <el-select v-model="queryForm.xnxqbm" placeholder="学年学期" style="width:180px;margin-top: 20px;" clearable>
                <el-option v-for="(item, index) in comboOption.semester" :key="item.comboValue" :value="item.comboValue"
                    :label="item.comboName">
                </el-option>
            </el-select>
            <el-input v-model="queryForm.jsxm" placeholder="教师姓名" style="width:180px;" clearable></el-input>
            <el-input v-model="queryForm.jsbh" placeholder="教师工号" style="width:180px;" clearable></el-input>

            <el-button @click="handleFilter" type="gray" style="margin-left: 10px"><i class="el-icon-search"></i>&nbsp;查询</el-button>
            <el-button @click="handleReset" type="gray"><i class="el-icon-refresh"></i>&nbsp;重置</el-button>
        </div>

        <!-- 列表区域 -->
        <div style="height: 56vh;overflow: auto">
        <el-table :data="tableData" @current-change="handleCurrentChange" v-loading.body="tableLoading"
            element-loading-text="信息加载中" stripe border fit highlight-current-row header-cell-class-name="tableHeadStyle"
            :height="mainTableHeight" ref="mainTable">
            <el-table-column label="序号" width="50" align="center">
                <template slot-scope="scope">
                    <span>{{(queryForm.pageNum - 1) * queryForm.rowNum + scope.$index + 1}}</span>
                </template>
            </el-table-column>
            <el-table-column label="学年学期" prop="xnxqmc" align="center"></el-table-column>
            <el-table-column label="教师工号" prop="jsbh" align="center"></el-table-column>
            <el-table-column label="教师姓名" prop="jsxm" align="center"></el-table-column>
            <el-table-column label="总分" prop="zf" align="center"></el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" size="small" @click="handleEdit(scope.$index, scope.row)">
                        <i class="el-icon-tickets"></i>&nbsp;详情
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        </div>

        <!-- 分页区域 -->
        <div class="pagination-container" style="text-align: left;">
            <el-pagination @size-change="handleSizeChange" @current-change="handlePageChange"
                :current-page.sync="queryForm.pageNum" :page-sizes="[10, 20, 50]" :page-size="queryForm.rowNum"
                layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>

        <!-- 详情框 -->
        <el-dialog :title="title" style="text-align: left;" width="1000px" top="250px" :visible.sync="dialogVisible">
            <div style="height: 400px;">
                <el-table :data="detailsTable" ref="detailsTable">
                    <el-table-column label="评价表名称" prop="pjbmc" align="center"></el-table-column>
                    <el-table-column label="最高分" prop="max" align="center" width="100px"></el-table-column>
                    <el-table-column label="最低分" prop="min" align="center" width="100px"></el-table-column>
                    <el-table-column label="平均分" prop="avg" align="center" width="100px"></el-table-column>
                    <el-table-column label="评教人数" prop="pjrs" align="center" width="100px"></el-table-column>
                    <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button type="primary" v-if="scope.row.lx == '03'" size="small"
                                @click="tkHandleEdit(scope.$index, scope.row)">
                                <i class="el-icon-tickets"></i>&nbsp;详情
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-dialog>

        <el-dialog title="title" style="text-align: left;" width="1200px" :visible.sync="tkDialogVisible">
            <div slot="title" style="margin-left: 30px;">
                <el-select v-model="tkbbh" style="width:600px;margin-top: 20px;" @change="changTkTable">
                    <el-option v-for="(item, index) in comboOption.tkCombo" :key="item.comboValue"
                        :value="item.comboValue" :label="item.comboName">
                    </el-option>
                </el-select>
            </div>
            <div style="height: 600px;overflow: auto;margin-left: 30px;" v-loading="tkLoading">
                    <queryTkEvaluate v-show="tkTableFlag" ref="queryTkEvaluate" :tkQueData="tkQueData"></queryTkEvaluate>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import queryTkEvaluate from "./queryTkEvaluate.vue"

    export default {
        components: {
            queryTkEvaluate,
        },
        data() {
            return {
                dialogVisible: false,
                queryForm: {
                    pageNum: 1,
                    rowNum: 10,
                    xnxqbm: '',
                    jsbh: '',
                    jsxm: ''
                },
                //下拉列表数据
                comboOption: {
                    semester: [],
                    tkCombo: []
                },
                //表数据
                tableData: [],
                //默认页数
                total: null,
                //选中行的数据
                selectRowData: null,
                tableLoading: true,
                mainTableHeight: 500,
                //详情
                detailsTable: [],
                title: '',
                //听课问卷
                tkDialogVisible: false,
                tkQueData: {
                    basicInfo: [],
                    pjxInfo: [],
                    hjdf: 0
                },
                paramMap: {
                    jsbh: '',
                    xnxqbm: ''
                },
                tkbbh: '', //听课表编号
                tkLoading : false,
                tkTableFlag:false
            }
        },
        mounted() {
            this.queryList();
            this.initCombo();
            this.$nextTick().then(() => {
                //this.$refs.table.$el.offsetTop：表格距离浏览器的高度
                //最后数字表示要调整的表格距离底部的高度（如预留分页组件的高度）
                this.mainTableHeight = window.innerHeight - this.$refs.mainTable.$el.offsetTop - 145;
                // 监听窗口大小变化
                let self = this;
                window.onresize = function() {
                    self.mainTableHeight = window.innerHeight - self.$refs.mainTable.$el.offsetTop - 145;
                };
            });
        },
        methods: {
            changTkTable() {
                this.tkTableFlag = false;
                this.tkLoading = true;
                this.$api.evaluateManage.questionnaireServer.openTkQue({
                        data: this.tkbbh
                    })
                    .then((res) => {
                        this.tkQueData.hjdf = 0;

                        this.tkQueData.basicInfo = res.data.data.basicInfo
                        this.tkQueData.pjxInfo = res.data.data.pjxInfo
                        this.tkQueData.basicInfo.jxnrgc = this.tkQueData.basicInfo.jxnrgc.replace(/\n/g,'<br>');
                        this.tkQueData.basicInfo.zhpjjy = this.tkQueData.basicInfo.zhpjjy.replace(/\n/g,'<br>');
                        for (var i = 0; i < this.tkQueData.pjxInfo.length; i++) {
                            this.tkQueData.hjdf += parseInt(this.tkQueData.pjxInfo[i].pf);
                        }

                        this.tkLoading = false;
                        this.tkTableFlag = true;
                    }).catch((err) => {
                        console.log(err);
                        this.tkLoading = false;
                    });
            },
            tkHandleEdit() {
                this.$api.evaluateManage.questionnaireServer.tkCombo({
                    data: this.paramMap,
                }).then((res) => {
                    this.comboOption.tkCombo = res.data.data
                    this.tkbbh = res.data.data[0].comboValue
                    this.changTkTable()
                }).catch((err) => {
                    console.log(err);
                });
                this.tkDialogVisible = true
            },
            handleEdit(index, row) {
                this.title = row.jsxm;
                this.dialogVisible = true;

                this.paramMap.jsbh = row.jsbh;
                this.paramMap.xnxqbm = row.xnxqbm;

                this.$api.evaluateManage.questionnaireServer.details({
                    data: this.paramMap
                }).then((res) => {
                    this.detailsTable = res.data.data;
                }).catch((err) => {
                    console.log(err);
                })
            },
            queryList() {
                this.tableLoading = true;
                this.$api.evaluateManage.questionnaireServer.queryList({
                    data: this.queryForm,
                }).then((res) => {
                    this.total = res.data.data.total;
                    this.tableData = res.data.data.list;
                    this.tableLoading = false;
                }).catch((err) => {
                    this.tableLoading = false;
                    console.log(err);
                });
            },
            //初始化下拉框
            initCombo() {
                this.$api.common.comboOption.semester({}).then((res) => {
                    this.comboOption.semester = res.data.data.comboData
                }).catch((err) => {
                    showNotify('错误', error, 'error', 3000);
                })
            },
            //页码区域方法
            handleCurrentChange(val, old) {
                this.selectRowData = val;
            },
            handleSizeChange(val) {
                this.queryForm.rowNum = val;
                this.queryForm.pageNum = 1;
                this.queryList();
            },
            handleFilter() {
                this.queryForm.pageNum = 1;
                this.queryList();
            },
            handlePageChange(val) {
                this.queryForm.pageNum = val;
                this.queryList();
            },
            handleReset() {
                this.queryForm.pageNum = 1;
                this.queryForm.rowNum = 10;
                this.queryForm.xnxqbm = '';
                this.queryForm.jsbh = '';
                this.queryForm.jsxm = '';
                this.tableLoading = false;
                this.queryList();
            },
        }
    };
</script>

<style>
</style>



// WEBPACK FOOTER //
// generalInfo.vue?5dc570aa